import { render } from "./AddLocationModal.vue?vue&type=template&id=22c6d0de&scoped=true"
import script from "./AddLocationModal.vue?vue&type=script&lang=js"
export * from "./AddLocationModal.vue?vue&type=script&lang=js"

import "./AddLocationModal.vue?vue&type=style&index=0&id=22c6d0de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c6d0de"]])

export default __exports__